import React, { useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Portal,
} from "@chakra-ui/react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Modal } from "antd";

import SampleCertificate from "./samples/certificate-sample.png";
import SampleIntro from "./samples/intro-video.mp4";
import SamplePerformance from "./samples/performance-video.mp4";

// Demo data based on type
const demoSamples = {
  certification: {
    type: "image",
    source: SampleCertificate,
    alt: "Sample Certificate",
    title: "Sample Image Certificate"
  },
  introVideo: {
    type: "video",
    source: SampleIntro,
    title: "Sample Intro Video"
  },
  performanceVideo: {
    type: "video",
    source: SamplePerformance,
    title: "Sample Performance Video"
  },
};

const PopoverInfo = ({ infoText, type }) => {
  const demo = demoSamples[type];
  const [isPreviewModal, setIsPreviewModal] = useState(false);

  const openPreviewModal = () => setIsPreviewModal(true);
  const closePreviewModal = () => setIsPreviewModal(false);

  return (
    <>
      <Popover placement="auto" isLazy>
        <PopoverTrigger>
          <button type="button">
            <InfoOutlinedIcon
              className="text-[#008080] ml-1 cursor-pointer"
              fontSize="small"
            />
          </button>
        </PopoverTrigger>

        <Portal>
          <PopoverContent
            bg="white"
            borderColor="gray.200"
            className="z-50 shadow-lg rounded-md p-2"
            maxW="90vw"
            w="auto"
            style={{
              overflowWrap: "break-word",
              whiteSpace: "normal",
            }}
          >
            <PopoverArrow />
            <PopoverBody className="text-sm text-gray-700 space-y-2">
              <div>{infoText}</div>
              {demo?.source && (
                <div
                  onClick={openPreviewModal}
                  className="text-blue-600 underline cursor-pointer text-xs"
                >
                  View Sample
                </div>
              )}
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>

      {/* Preview Modal */}
      {isPreviewModal && <Modal
        open={isPreviewModal}
        onCancel={closePreviewModal}
        footer={null}
        centered
        title={demo?.title || ""}
        width="auto"
        styles={{
          padding: 14,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="max-h-[80vh] w-full flex justify-center items-center">
          {demo?.type === "video" ? (
            <video
              src={demo?.source}
              controls
              className="max-h-[80vh] w-auto rounded-md"
            />
          ) : (
            <img
              src={demo?.source}
              alt={demo?.alt || "Sample"}
              className="max-h-[80vh] w-auto rounded-md"
            />
          )}
        </div>
      </Modal>}
    </>
  );
};

export default PopoverInfo;
